import { useApp } from './store';

export function LangToggle() {
  const { lang, toggleLang } = useApp();
  return (
    <button onClick={toggleLang} style={{
      background: 'transparent',
      border: '1px solid rgba(255,255,255,0.18)',
      color: '#8BA8D4',
      fontSize: 11,
      fontWeight: 700,
      borderRadius: 5,
      padding: '3px 7px',
      cursor: 'pointer',
      letterSpacing: 0.5,
      lineHeight: 1,
      flexShrink: 0,
    }}>
      {lang === 'zh' ? 'EN' : 'ZH'}
    </button>
  );
}

export const STRINGS = {
  // ── General ──
  loading:          { zh: '加载中...', en: 'Loading...' },
  back:             { zh: '返回', en: 'Back' },
  confirm:          { zh: '确认', en: 'Confirm' },
  cancel:           { zh: '取消', en: 'Cancel' },
  copy:             { zh: '复制', en: 'Copy' },
  copied:           { zh: '已复制', en: 'Copied' },
  save:             { zh: '保存', en: 'Save' },
  submit:           { zh: '提交', en: 'Submit' },
  refresh:          { zh: '刷新', en: 'Refresh' },
  close:            { zh: '关闭', en: 'Close' },

  // ── Auth ──
  authSubtitle:     { zh: '1000倍杠杆合约对战 · 万人同房竞技 · 赢家瓜分奖池', en: '1000x Leverage PvP · Mass Room Battle · Winners Split the Pool' },
  loginTab:         { zh: '登录', en: 'Login' },
  registerTab:      { zh: '注册', en: 'Register' },
  emailLabel:       { zh: '邮箱', en: 'Email' },
  passwordLabel:    { zh: '密码', en: 'Password' },
  nicknameLabel:    { zh: '昵称（选填）', en: 'Nickname (optional)' },
  inviteCodeLabel:  { zh: '邀请码（选填）', en: 'Invite Code (optional)' },
  verifyCodeLabel:  { zh: '验证码', en: 'Verification Code' },
  sendCode:         { zh: '发送验证码', en: 'Send Code' },
  sendingCode:      { zh: '发送中...', en: 'Sending...' },
  codeSent:         { zh: '重新发送', en: 'Resend' },
  loginBtn:         { zh: '登录', en: 'Login' },
  registerBtn:      { zh: '注册', en: 'Register' },
  loggingIn:        { zh: '登录中...', en: 'Logging in...' },
  registering:      { zh: '注册中...', en: 'Registering...' },
  switchToRegister: { zh: '没有账号？注册', en: 'No account? Register' },
  switchToLogin:    { zh: '已有账号？登录', en: 'Have account? Login' },
  passkeyLogin:     { zh: '免密码登录（Passkey）', en: 'Passwordless Login (Passkey)' },
  passkeyBind:      { zh: '绑定 Passkey', en: 'Bind Passkey' },
  passkeyBinding:   { zh: '验证中...', en: 'Verifying...' },

  // ── Lobby ──
  welcomeBack:      { zh: '欢迎回来', en: 'Welcome back' },
  pointBalance:     { zh: '积分余额', en: 'Point Balance' },
  sellCard:         { zh: '房卡出售', en: 'Sell Cards' },
  claimCard:        { zh: '领房卡', en: 'Get Cards' },
  claimPoints:      { zh: '领积分', en: 'Get Points' },
  leaderboard:      { zh: '排行榜', en: 'Ranks' },
  friendBattle:     { zh: '好友对战', en: 'Friend PvP' },
  ledger:           { zh: '流水', en: 'Ledger' },
  adminLabel:       { zh: '后台', en: 'Admin' },
  marketSection:    { zh: '行情', en: 'Market' },
  chooseBattlefield:{ zh: '选择战场', en: 'Choose Arena' },
  gameRulesTitle:   { zh: '玩法规则', en: 'How to Play' },
  startMatch:       { zh: '开始匹配', en: 'Enter' },
  noCard:           { zh: '缺房卡', en: 'No Card' },
  noPoints:         { zh: '积分不足', en: 'Low Points' },
  carryLabel:       { zh: '携带', en: 'Carry' },
  navHome:          { zh: '首页', en: 'Home' },
  navTasks:         { zh: '任务', en: 'Tasks' },
  navInvite:        { zh: '邀请', en: 'Invite' },
  navWithdraw:      { zh: '提现', en: 'Withdraw' },
  roomStatusIdle:   { zh: '空闲', en: 'Idle' },

  // room names & tags
  beginnerRoom:     { zh: '初级场', en: 'Beginner' },
  midRoom:          { zh: '中级场', en: 'Intermediate' },
  advRoom:          { zh: '高级场', en: 'Advanced' },
  newbieTag:        { zh: '新手入门', en: 'Starter' },
  advancedTag:      { zh: '进阶对决', en: 'Advanced' },
  eliteTag:         { zh: '精英战场', en: 'Elite' },

  // rules
  rule1Title:       { zh: '60秒对局', en: '60-Second Round' },
  rule1Desc:        { zh: '每局60秒，做多/做空$ANSEM实时价格', en: '60s per round, go long or short on live $ANSEM price' },
  rule2Title:       { zh: '1000倍杠杆', en: '1000x Leverage' },
  rule2Desc:        { zh: '方向正确大幅盈利，反向0.1%即爆仓', en: 'Correct direction = big gain, wrong = bust at 0.1%' },
  rule3Title:       { zh: '爆仓奖池', en: 'Bust Pool' },
  rule3Desc:        { zh: '出局玩家积分进入奖池，幸存者瓜分', en: "Busted players' points go to pool, survivors split it" },

  // ── Game ──
  longUp:           { zh: '看涨↑', en: 'Long↑' },
  shortDown:        { zh: '看跌↓', en: 'Short↓' },
  longActive:       { zh: '看涨中…', en: 'Going Long…' },
  shortActive:      { zh: '看跌中…', en: 'Going Short…' },
  switchToLong:     { zh: '切换至 看涨↑', en: 'Switch to Long↑' },
  switchToShort:    { zh: '切换至 看跌↓', en: 'Switch to Short↓' },
  submitting:       { zh: '提交中…', en: 'Submitting…' },
  bustWaiting:      { zh: '已爆仓，等待本局结束...', en: 'Busted. Waiting for round to end...' },
  gameStarting:     { zh: '游戏开始倒计时', en: 'Game starting' },
  waitingPlayers:   { zh: '等待玩家加入...', en: 'Waiting for players...' },
  readyBtn:         { zh: '准备出战', en: 'Ready' },
  alreadyReady:     { zh: '已准备，等待开局', en: 'Ready, waiting to start' },
  loadingMarket:    { zh: '行情加载中...', en: 'Loading market...' },
  bustPool:         { zh: '本局总奖池', en: 'Total Bust Pool' },
  streakLabel:      { zh: '连胜', en: 'Streak' },
  segKeep:          { zh: '继续保持不要切换', en: 'Keep going, stay the course' },
  segReset:         { zh: '连胜中断 — 盈利时切换才能连胜', en: 'Streak broken — switch only when profitable' },
  streakBonus:      { zh: '连胜奖励', en: 'Streak Bonus' },
  firstTip:         { zh: '盈利后切换方向可叠加连胜，最高 x5 暴击奖励', en: 'Switch direction after profit to chain streaks, up to x5 crit bonus' },

  // settle modal
  settleTitle:      { zh: '本局结算', en: 'Round Result' },
  settleRank:       { zh: '排名', en: 'Rank' },
  settlePlayer:     { zh: '玩家', en: 'Player' },
  settleCarry:      { zh: '携带', en: 'Carry' },
  settleShare:      { zh: '分成', en: 'Share' },
  settleTotal:      { zh: '结算', en: 'Total' },
  settleYou:        { zh: '你', en: 'You' },
  settleBust:       { zh: '爆仓', en: 'Bust' },
  nextRound:        { zh: '下一局', en: 'Next Round' },
  returnLobby:      { zh: '返回大厅', en: 'Back to Lobby' },

  // ── FriendLobby / FriendGame ──
  friendBattleTitle:{ zh: '好友对战', en: 'Friend Battle' },
  createRoom:       { zh: '创建房间', en: 'Create Room' },
  joinRoom:         { zh: '加入房间', en: 'Join Room' },
  roomCodeLabel:    { zh: '房间码', en: 'Room Code' },
  enterRoomCode:    { zh: '输入房间码', en: 'Enter Room Code' },
  yourName:         { zh: '你的游戏名字', en: 'Your Name' },
  enterName:        { zh: '请输入一个名字', en: 'Please enter a name' },
  copyLink:         { zh: '复制链接', en: 'Copy Link' },
  linkCopied:       { zh: '✓ 已复制', en: '✓ Copied' },
  waitingFriends:   { zh: '等待玩家加入...', en: 'Waiting for players...' },
  startGame:        { zh: '开始游戏', en: 'Start Game' },
  waitHost:         { zh: '等待房主开始...', en: 'Waiting for host...' },
  hostLabel:        { zh: '房主', en: 'Host' },
  eachCarries:      { zh: '每人携带', en: 'Each player carries' },
  friendSettleTitle:{ zh: '游戏结束', en: 'Game Over' },
  playAgain:        { zh: '再来一局', en: 'Play Again' },
  backLobby:        { zh: '返回大厅', en: 'Back to Lobby' },
  connecting:       { zh: '连接中...', en: 'Connecting...' },
  joinGame:         { zh: '加入游戏', en: 'Join Game' },
  disconnectWarn:   { zh: '秒后爆仓，正在重连...', en: 's until bust, reconnecting...' },
  networkDisconnect:{ zh: '网络断线！', en: 'Disconnected!' },

  // ── Leaderboard ──
  leaderboardTitle: { zh: '排行榜', en: 'Leaderboard' },
  tabDaily:         { zh: '今日', en: 'Today' },
  tabAll:           { zh: '总榜', en: 'All Time' },
  tabBest:          { zh: '最强交易员', en: 'Best Trader' },
  rankLabel:        { zh: '名次', en: 'Rank' },
  playerLabel:      { zh: '玩家', en: 'Player' },
  pointsLabel:      { zh: '积分', en: 'Points' },
  singleBest:       { zh: '单局最高', en: 'Best Round' },
  noData:           { zh: '暂无数据', en: 'No data yet' },

  // ── Ledger ──
  ledgerTitle:      { zh: '流水记录', en: 'Transaction History' },
  typeLabel:        { zh: '类型', en: 'Type' },
  amountLabel:      { zh: '数量', en: 'Amount' },
  timeLabel:        { zh: '时间', en: 'Time' },
  noteLabel:        { zh: '备注', en: 'Note' },
  prevPage:         { zh: '上一页', en: 'Prev' },
  nextPage:         { zh: '下一页', en: 'Next' },

  // ── Withdraw ──
  withdrawTitle:    { zh: '提现', en: 'Withdraw' },
  walletAddress:    { zh: '钱包地址', en: 'Wallet Address' },
  withdrawAmount:   { zh: '提现数量', en: 'Amount' },
  withdrawBtn:      { zh: '申请提现', en: 'Request Withdrawal' },
  withdrawHistory:  { zh: '提现记录', en: 'Withdrawal History' },
  withdrawStatus:   { zh: '状态', en: 'Status' },
  txHash:           { zh: '交易哈希', en: 'Tx Hash' },
  withdrawPending:  { zh: '处理中', en: 'Pending' },
  withdrawSuccess:  { zh: '成功', en: 'Success' },
  withdrawFailed:   { zh: '失败', en: 'Failed' },

  // ── Invite ──
  inviteTitle:      { zh: '邀请好友', en: 'Invite Friends' },
  inviteLink:       { zh: '我的邀请链接', en: 'My Invite Link' },
  inviteReward:     { zh: '邀请奖励', en: 'Invite Rewards' },
  pendingReward:    { zh: '待领取', en: 'Pending' },
  claimReward:      { zh: '领取', en: 'Claim' },
  invitedFriends:   { zh: '已邀请好友', en: 'Friends Invited' },

  // ── Tasks ──
  taskTitle:        { zh: '任务', en: 'Tasks' },
  taskReward:       { zh: '奖励', en: 'Reward' },
  taskGo:           { zh: '去完成', en: 'Go' },
  taskDone:         { zh: '已完成', en: 'Done' },

  // ── BuyCard / CardSale ──
  buyCardTitle:     { zh: '购买房卡', en: 'Buy Room Cards' },
  cardSaleTitle:    { zh: '房卡出售', en: 'Sell Room Cards' },
  cardUnit:         { zh: '张', en: '' },
  roomCard:         { zh: '房卡', en: 'Room Cards' },
};

export function useLang() {
  const { lang } = useApp();
  const t = (key) => STRINGS[key]?.[lang] ?? STRINGS[key]?.zh ?? key;
  return { t, lang };
}
